@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.pilates.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.pilates.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_985_402_296)
internal val Res.font.paytoneone_regular: FontResource by lazy {
      FontResource("font:paytoneone_regular", setOf(
        ResourceItem(setOf(), "${MD}font/paytoneone-regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("paytoneone_regular", Res.font.paytoneone_regular)
}
